<h4 class="mb-4">Add Catalog Items from the selected Worksheet(s)</h4>
<div class="alert alert-warning mb-4">
	NOTE: Worksheets can include multiple Catalog templates, but some template associations may not be allowed on the
	current Record. Only the allowed Catalog items (set within Configuration) will be associated to this Record.
</div>
<div>
	<rl-grid [dataSource]="dataSource"></rl-grid>
</div>